import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Activity } from "lucide-react";
import { TOOLS } from "@/constants";
import Disclaimer from "@/components/shared/Disclaimer";
import Footer from "@/components/shared/Footer";
import { useEngagementTracker } from "@/hooks/useEngagementTracker";

const ToolsPage = () => {
  const { trackEvent } = useEngagementTracker();
  
  // Track page view
  useEffect(() => {
    trackEvent('tools_hub', 'view');
  }, [trackEvent]);
  
  const handleToolClick = (toolId) => {
    trackEvent(toolId, 'click');
  };
  
  return (
    <main className="min-h-screen" style={{ 
      background: 'linear-gradient(180deg, #f0f7ff 0%, #ffffff 30%, #f8fbff 100%)'
    }} data-testid="tools-page">
      <Disclaimer />
      
      <div className="relative z-10 container-shell py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-slate-800">Platform Tools</h1>
          <p className="text-slate-500">Legal intelligence suite with live public records integration</p>
        </div>
        
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {TOOLS.map((tool, i) => (
            <Link to={`/tools/${tool.id}`} key={tool.id} onClick={() => handleToolClick(tool.id)}>
              <div className={`h-full bg-white rounded-xl p-6 border border-slate-100 shadow-sm hover:shadow-lg transition-all hover:-translate-y-1 ${tool.isNew ? 'ring-2 ring-cyan-400' : ''} ${tool.isPremium ? 'ring-2 ring-red-400' : ''}`}>
                <div className="flex items-start justify-between mb-4">
                  <div className="w-14 h-14 rounded-xl flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #dbeafe, #eff6ff)' }}>
                    <tool.icon className="h-7 w-7 text-blue-600" />
                  </div>
                  <div className="flex gap-1">
                    {tool.isPremium && (
                      <span className="px-2 py-1 text-xs font-semibold rounded bg-red-100 text-red-600">PREMIUM</span>
                    )}
                    {tool.isNew && !tool.isPremium && (
                      <span className="px-2 py-1 text-xs font-semibold rounded bg-cyan-100 text-cyan-600">NEW</span>
                    )}
                    {tool.live && (
                      <span className="px-2 py-1 text-xs font-semibold rounded bg-emerald-100 text-emerald-600">LIVE</span>
                    )}
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-slate-800 mb-2">{tool.name}</h3>
                <p className="text-slate-500 text-sm">{tool.desc}</p>
              </div>
            </Link>
          ))}
        </div>
        
        <div className="mt-8 bg-gradient-to-r from-blue-600 to-blue-500 rounded-xl p-6 text-white">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0 bg-white/20">
                <Activity className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">Historical Pattern Analysis</h3>
                <p className="text-blue-100 text-sm">
                  All analytics are based on historical public records and aggregated court data. 
                  Judge, Attorney, Party, and Precedent tools connect to CourtListener's database.
                  The Strategy Pattern Report provides comprehensive litigation benchmarks for case planning.
                </p>
              </div>
            </div>
        </div>
      </div>
      <Footer />
    </main>
  );
};


export default ToolsPage;
